<template>
  <div class="ag-theme-alpine my-grid-custom" :style="'width: 100%; height:' + gridHeight">
    <ag-grid-vue      
      :style="'width:100%; height:' + gridHeight"
      class="ag-theme-alpine"
      :columnDefs="columnDefs"
      :rowData="rowData"
      @grid-ready="onGridReady"
      @column-resized="onColumnResized"
      @column-moved="emitColumnState"
      @column-visible="emitColumnState"
      :defaultColDef="defaultColDef"
      :headerHeight="32"
      :rowHeight="rowHeight"         
      :domLayout="'normal'"
      :getRowStyle="getRowStyle"
      :grandTotalRow="'bottom'"
    >
    </ag-grid-vue>          
  </div>  
</template>

<script>
  import { AgGridVue } from "ag-grid-vue";
  import "ag-grid-community/dist/styles/ag-grid.css";
  import "ag-grid-community/dist/styles/ag-theme-alpine.css";  

  export default {    
    props:{
      columns: {
        type: [Object, Array],
        default: () => [],
      },      
      dataRow: {
        type: [Object, Array],
        default: () => [],
      },
      dataTotal:{
        type: [Object, Array],
        default: () => [],
      },
      rowHeight: {
        type: Number,
        default: 28,
      },
      gridHeight: {
        type: String,
        default: '50vh',
      },
      columnState: {
        type: Array,
        default: () => [],
      },
    },       
    components: {      
      AgGridVue
    },
    data: () => {
      return {
        columnDefs: [],
        rowData: [],
        defaultColDef: {
          resizable: true,
          sortable: true,
          filter: true,    
        }          
      }
    },
    mounted() {     
      this.columnDefs = this.columns
      this.rowData = this.dataRow      
    },    
    methods: {      
      onGridReady(params) {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;

        this.applyColumnState()
        
        if(this.dataTotal.length > 0) {
          this.gridApi.setPinnedBottomRowData(this.dataTotal);
        }

        /*
        setTimeout(() => {
          this.gridApi.sizeColumnsToFit();
        }, 0);        
        */
      }, 
      getRowStyle(params) {
        if (params.node.rowPinned === 'bottom') {
          return { 
            fontWeight: 'bold',
            backgroundColor: '#f5f5f5' 
          };
        }
        return null;
      },
      setColumnVisibility(field, visible) {
        if(this.columnApi) this.columnApi.setColumnVisible(field, visible)
      },
      applyColumnState() {
        if(this.columnApi && this.columnState.length) {
          this.columnApi.applyColumnState({ state: this.columnState, applyOrder: true })
        }
      },
      getColumnState() {
        return this.columnApi ? this.columnApi.getColumnState() : []
      },
      onColumnResized(event) {
        if(event.finished) this.emitColumnState()
      },
      emitColumnState() {
        if(this.columnApi) this.$emit('column-state-change', this.columnApi.getColumnState())
      }
    }
  }  
</script>
<style>
  .my-grid-custom .ag-cell-value {
    align-content: space-around;
    line-height: normal;
  }
</style>
